import React, { useState } from 'react';
import Layout from '../components/Layout';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    // You can add API call here
  };

  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Contact</h1>
                <p className="colorWht">Green Orange Information Technology</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="col-lg-12">
            <div className="container contactus">
              <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-6">
                  <h3>India</h3>
                  <h4>
                    GreenOrange Information Technology<br />
                    Private Limited
                  </h4>
                  <p>
                    G-36 &amp; 37, Tidel Park, ELCOT SEZ<br />
                    Vilankurichi Road, Civil Aerodrome Post,<br />
                    Coimbatore-641014, Tamilnadu, India<br />
                    Email: sales@greenorange.in<br /> Telephone: +91 422 435 5160
                  </p>
                  <h3>Malaysia</h3>
                  <h4>AOT TECHNOLOGIES SDN BHD.</h4>
                  <p>
                    No 10-1, 1st Floor, Jalan Putra Mahkota <br />
                    7/5B, Putra Point Business Centre - 47650<br /> Subang Jaya. Selangor.<br />
                    Email: sales@aottec.com<br />
                    Telephone: +60 10-252 3658
                  </p>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-6">
                  <h3>Contact Us</h3>
                  <form
                    name="chatform"
                    id="chatform"
                    action="http://niyaz.greenorange.in/ReachMe?auth=1"
                    method="post"
                    target="myFrame"
                    className="padT8"
                    onSubmit={handleSubmit}
                  >
                    <div className="twoCols">
                      <p>
                        <i className="fa fa-user"></i>
                        <span>
                          <input
                            type="text"
                            aria-invalid="false"
                            aria-required="true"
                            className="form-control"
                            size="40"
                            placeholder="Full Name*"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </p>
                      <p>
                        <i className="fa fa-building"></i>
                        <span>
                          <input
                            type="text"
                            aria-invalid="false"
                            aria-required="true"
                            className="form-control"
                            size="40"
                            placeholder="Company Name*"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </p>
                    </div>
                    <div className="twoCols">
                      <p>
                        <i className="fa fa-envelope"></i>
                        <span>
                          <input
                            type="email"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                            aria-invalid="false"
                            aria-required="true"
                            className="form-control"
                            size="40"
                            placeholder="Email*"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </p>
                      <p>
                        <i className="fa fa-mobile mob_icon"></i>
                        <span>
                          <input
                            type="text"
                            pattern="^([0|\+[0-9]{1,5})?([1-9][0-9]{9})$"
                            aria-invalid="false"
                            aria-required="true"
                            className="form-control"
                            size="15"
                            placeholder="Mobile Number*"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </span>
                      </p>
                    </div>
                    <div className="twoCols textfeild">
                      <p>
                        <i className="fa fa-pencil"></i>
                        <span>
                          <textarea
                            aria-invalid="false"
                            aria-required="true"
                            className="form-control"
                            rows="5"
                            cols="40"
                            placeholder="Your Requirement*"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </span>
                      </p>
                    </div>
                    <div className="twoCols textfeild text-right">
                      <p>
                        <input
                          className="btn btn-lg btn-primary form-submit"
                          type="submit"
                          name="submit"
                          value="Submit"
                        />
                      </p>
                    </div>
                  </form>
                  <iframe
                    src=""
                    id="myFrame"
                    name="myFrame"
                    title="Contact Form Response"
                    style={{ color: '#527902', width: '70%', border: 0 }}
                  >
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
      </section>
    </Layout>
  );
};

export default Contact;

